import toUpper from 'lodash/toUpper'

export const replaceStateName = (state) => {
  const stateFormat = toUpper(state)

  const stateList = {
    AC: "do Acre",
    AL: "de Alagoas",
    AP: "de Amapá",
    AM: "do Amazonas",
    BA: "da Bahia",
    CE: "do Ceará",
    ES: "de Espírito Santo",
    GO: "de Goiás",
    MA: "do Maranhão",
    MT: "de Mato Grosso",
    MS: "do Mato Grosso do Sul",
    MG: "de Minas Gerais",
    PA: "do Pará",
    PB: "da Paraíba",
    PR: "do Paraná",
    PE: "de Pernambuco",
    PI: "do Piauí",
    RJ: "do Rio de Janeiro",
    RN: "do Rio Grande do Norte",
    RS: "do Rio Grande do Sul",
    RO: "de Rondônia",
    RR: "de Roraima",
    SC: "de Santa Catarina",
    SP: "de São Paulo",
    SE: "de Sergipe",
    TO: "do Tocantins",
    DF : "do Distrito Federal",
  }

  return stateList[stateFormat] || key
}

export const replaceCityName = (city) => {
  return `em ${city}`
}

/**
 * @param {string} text
 * @param {ApiCategoryDirectoryLocation} location
 * @param {string} [template='{local}']
 * @returns
 */
export const replaceLocation = (text, location, template = '{local}') => {
  if (text == null || text == '') {
    return text
  }

  const replaceValue = location.nameCity !== null
    ? replaceCityName(location.nameCity)
    : replaceStateName(location.ufState)

  return text.replace(template, replaceValue)
}

export default {
  replaceStateName,
  replaceCityName,
  replaceStateName,
}